module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 27@2x.96da4816.png";